module.exports = __webpack_public_path__ + "img/menuIcon17.afc463b6.png";